const levelRegex = /Hp(\d+)/i;
export const parseHealth = (name) => {
    let level = null;
    const m = name.match(levelRegex);
    if (m !== null) {
        level = parseInt(m[1], 10);
    }
    return level;
};
